import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { truncateSplitCharacters } from '@Utils/String';
import useBreakpoint from '@Hooks/useBreakpoint';
import { LinkElement } from '@els/els-react--link-element';

import './QuickResultsHeading.scss';

const MAX_QUERY_LENGTH = 70;

function QuickResultsHeading(props) {
  const { isQueryEnabled, query, structurePreview, goToNewSearch, goToEditSearch, showStructurePopup } = props;
  const isDesktop = useBreakpoint('tablet');

  const handleSearchStructureButtonClick = () => {
    showStructurePopup(structurePreview);
  };

  return (
    <div className="quick-results-heading e2e-quick-results-heading">
      <div className="quick-results-heading__wrapper">
        {!isQueryEnabled && (
          <div className="quick-results-heading__emptyTitle">
            <h1 className="quick-results-heading__emptyTitle_label">No Query Available </h1>
            <span className="quick-results-heading__emptyTitle_description">Please enter a query</span>
          </div>
        )}

        {isQueryEnabled && (
          <div className="quick-results-heading__title">
            <div className="quick-results-heading__title_label">
              <h2 className="u-els-font-size-h3 u-els-font-family-bold u-els-margin-right-1o2 quick-results-heading__title_label_heading">Results for</h2>
              {((query && query.length < MAX_QUERY_LENGTH) || isDesktop) && (
                <div className="u-els-display-flex">
                  {query && <h2 className="u-els-font-size-h3">{truncateSplitCharacters(query, MAX_QUERY_LENGTH)}</h2>}
                  {query && structurePreview && <h3>AND</h3>}
                  {structurePreview && (
                    <ButtonWithIcon
                      type="secondary"
                      size="small"
                      sprite="Structure"
                      iconOnly
                      data-e2e="e2e-quick-results-heading-showStructure"
                      tabIndex="0"
                      onClick={handleSearchStructureButtonClick}
                      className="u-els-margin-left-1o2 quick-results-heading__structure">
                      Expand substance structure in modal
                    </ButtonWithIcon>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
        {isQueryEnabled && (
          <div className="quick-results-heading__buttons" aria-label="Search Actions">
            <LinkElement
              href="#"
              iconSprite="Redo"
              iconSize="xs"
              iconRight
              data-e2e="e2e-quick-results-heading-new"
              onClick={(event) => {
                event.preventDefault();
                goToNewSearch();
              }}
              className="e2e-quick-results-heading-new"
              aria-label="Start new search in Reaxys">
              New
            </LinkElement>

            <LinkElement
              href="#"
              iconSprite="Note"
              iconSize="xs"
              data-e2e="e2e-quick-results-heading-edit"
              iconRight
              onClick={(event) => {
                event.preventDefault();
                goToEditSearch();
              }}
              className="u-els-margin-left e2e-quick-results-heading-edit"
              aria-label="Edit query">
              Edit query
            </LinkElement>
          </div>
        )}
      </div>
      {query && query.length > MAX_QUERY_LENGTH && !isDesktop && (
        <div className="u-els-display-flex quick-results-heading__wrapper">
          {query && <h3>{truncateSplitCharacters(query, MAX_QUERY_LENGTH)}</h3>}
          {query && structurePreview && <h3>AND</h3>}
          {structurePreview && (
            <ButtonWithIcon
              type="secondary"
              size="small"
              sprite="Structure"
              data-e2e="e2e-quick-results-heading-showStructure"
              iconOnly
              tabIndex="0"
              onClick={handleSearchStructureButtonClick}
              className="u-els-margin-left-1o2 quick-results-heading__structure">
              Expand substance structure in modal
            </ButtonWithIcon>
          )}
        </div>
      )}
    </div>
  );
}

QuickResultsHeading.propTypes = {
  isQueryEnabled: PropTypes.bool,
  query: PropTypes.string,
  structurePreview: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  goToNewSearch: PropTypes.func.isRequired,
  goToEditSearch: PropTypes.func.isRequired,
  showStructurePopup: PropTypes.func.isRequired,
};

export default QuickResultsHeading;
